const sendToApp = (payload: Record<string, any>) => {
  if (window) {
    const encodedData = window?.btoa?.(JSON.stringify(payload))

    if (window?.ReactNativeWebView) {
      window?.ReactNativeWebView?.postMessage(encodedData)
    } else if (window?.android?.__externalCall) {
      window?.android?.__externalCall(encodedData)
    } else if (window?.__externalCall) {
      window?.__externalCall(encodedData)
    } else if (/iPad|iPhone|iPod/.test(window?.navigator?.userAgent)) {
      window?.webkit?.messageHandlers?.callback?.postMessage(encodedData)
    }
  }
}

export { sendToApp }
